import { ref, onServerPrefetch, onMounted } from 'vue'


export const attemptServerPrefetch = (fn: () => Promise<void>) => {
  const serverPrefetchFailed = ref(false)

//   onServerPrefetch(() => {
//     try{
//         fn();
//     }catch(err){
//         serverPrefetchFailed.value = true;
//     }
//   })

  onMounted(fn)
}